/** @license ISC License (c) copyright 2016 original and current authors */
/** @author Ian Hofmann-Hicks (evil) */

var VERSION = 2

var _implements = require('../core/implements')
var _inspect = require('../core/inspect')
var _equals = require('../core/equals')
var type = require('../core/types').type('Sum')
var _type = require('../core/types').typeFn(type(), VERSION)
var fl = require('../core/flNames')

var isNil = require('../core/isNil')
var isNumber = require('../core/isNumber')
var isSameType = require('../core/isSameType')

var _empty =
  function () { return Sum(0); }

function Sum(n) {
  var obj;

  var x = isNil(n) ? _empty().valueOf() : n

  if(!arguments.length || !isNumber(x)) {
    throw new TypeError('Sum: Numeric value required')
  }

  var valueOf =
    function () { return x; }

  var empty=
    _empty

  var inspect =
    function () { return ("Sum" + (_inspect(valueOf()))); }

  var equals =
    function (m) { return isSameType(Sum, m)
      && _equals(x, m.valueOf()); }

  function concat(method) {
    return function(m) {
      if(!isSameType(Sum, m)) {
        throw new TypeError(("Sum." + method + ": Sum required"))
      }

      return Sum(x + m.valueOf())
    }
  }

  return ( obj = {
    inspect: inspect, toString: inspect, valueOf: valueOf,
    equals: equals, type: type, empty: empty,
    concat: concat('concat')
  }, obj[fl.equals] = equals, obj[fl.empty] = empty, obj[fl.concat] = concat(fl.concat), obj['@@type'] = _type, obj.constructor = Sum, obj )
}

Sum['@@implements'] = _implements(
  [ 'equals', 'concat', 'empty' ]
)

Sum.empty = _empty
Sum.type = type

Sum[fl.empty] = _empty
Sum['@@type'] = _type

module.exports = Sum
